module.exports = __webpack_public_path__ + "img/message-x-circle.f8c35c3d.svg";